import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class PaginationProgress extends HTMLElement {
  total = this.dataset.total;
  fromElement = this.querySelector('[data-pagination-from]');
  toElement = this.querySelector('[data-pagination-to]');
  bar = this.querySelector('[data-pagination-bar]');

  connectedCallback() {
    this.unsubscribe = Pubsub.subscribe('load-more:success', () => this.update());
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  /**
   * Update the viewing range based on the product cards currently in the grid.
   * Product card list items carry their absolute position in their id
   * (product-card--{n}), so the min/max ids give the visible range in both
   * the load more and load previous direction.
   */
  update() {
    const positions = [
      ...document.querySelectorAll('[data-products-list] li[id^="product-card--"]'),
    ].map(({ id }) => Number(id.replace('product-card--', '')));

    if (!positions.length) return;

    const from = Math.min(...positions);
    const to = Math.max(...positions);

    this.fromElement.textContent = from;
    this.toElement.textContent = to;
    this.bar.style.marginLeft = `${((from - 1) / this.total) * 100}%`;
    this.bar.style.width = `${((to - from + 1) / this.total) * 100}%`;
  }
}

customElements.define('pagination-progress', PaginationProgress);
